module.exports = __webpack_public_path__ + "static/media/bullet-icon.05e84a36.svg";